import React from 'react';

import { withAppStepsState } from "./../../shared/containers/containerAppStepsState"
import { withResultPageState } from "../../shared/containers/containerResultPageState"

import FirstTitle from "./../../shared/items/static/firstTitle"
import OpenStepsAppButton from "./../../shared/openStepsAppButton"

import styles from './home.module.scss'

const Home = props => {
  const { isOpenAppSteps, openResultPage } = props

  return !openResultPage
    ? <div className={isOpenAppSteps ? styles.homePageHidden : styles.homePage}>
      <div className={styles.container_mainImage}>
        <img className={styles.mainImage} src="./img/main_back.png" alt="" />
      </div>
      <div className={styles.container_logo}>
        <img className={styles.logo} src="./img/logo.png" alt="" />
      </div>
      <div className={styles.container_shortCaption}>
        <span className={styles.shortCaption}>Take 1-Minute Quiz</span>
      </div>
      <div className={styles.container_caption}>
        <FirstTitle>Get your customized meal & workout plan</FirstTitle>
      </div>
      <div className={styles.container_buttonApp}>
        <OpenStepsAppButton>Continue</OpenStepsAppButton>
      </div>
    </div>
    : null
}

export default withAppStepsState(withResultPageState(Home));